module.exports = __webpack_public_path__ + "img/background.e2a09c1b.png";